const flowSteps = [
  {
    step: 'STEP 1',
    title: 'ご予約',
    image: 'https://public.readdy.ai/ai/img_res/728ce9b3b98011b16d82be6d8a61832f.jpg',
    description: 'お電話またはWebからご予約ください。ご希望の日時をお伺いし、お客様のご都合に合わせて調整いたします。',
    bgColor: 'bg-primary/10',
  },
  {
    step: 'STEP 2',
    title: 'ご来店',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20patient%20arriving%20at%20modern%20acupuncture%20clinic%20entrance%2C%20friendly%20receptionist%20greeting%20with%20warm%20smile%2C%20bright%20clean%20reception%20area%20with%20natural%20wood%20elements%20and%20green%20plants%2C%20welcoming%20atmosphere%2C%20professional%20healthcare%20setting%2C%20natural%20daylight%2C%20realistic%20photography&width=600&height=400&seq=flow-arrival&orientation=landscape',
    description: 'ご予約時間の15分前にご来店ください。受付でお名前をお伝えいただき、リラックスしてお待ちください。',
    bgColor: 'bg-accent/20',
  },
  {
    step: 'STEP 3',
    title: '問診票記入',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20patient%20filling%20out%20medical%20questionnaire%20form%20at%20clinic%2C%20sitting%20in%20comfortable%20waiting%20area%2C%20writing%20on%20clipboard%2C%20calm%20and%20focused%20expression%2C%20modern%20clean%20interior%20with%20soft%20lighting%2C%20professional%20healthcare%20environment%2C%20natural%20realistic%20photography&width=600&height=400&seq=flow-questionnaire&orientation=landscape',
    description: '現在のお悩みや症状、体調について問診票にご記入いただきます。気になることは何でもお書きください。',
    bgColor: 'bg-sub',
  },
  {
    step: 'STEP 4',
    title: '施術',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20acupuncturist%20performing%20treatment%20on%20patient%20in%20modern%20clinic%20room%2C%20professional%20and%20gentle%20care%2C%20patient%20lying%20comfortably%20on%20treatment%20bed%2C%20clean%20bright%20treatment%20room%20with%20natural%20lighting%2C%20calm%20and%20therapeutic%20atmosphere%2C%20realistic%20medical%20photography%2C%20focus%20on%20professional%20technique&width=600&height=400&seq=flow-treatment&orientation=landscape',
    description: '問診票を基にカウンセリングを行い、お一人おひとりに合わせた施術を丁寧に行います。痛みや不安があればすぐにお伝えください。',
    bgColor: 'bg-primary/10',
  },
  {
    step: 'STEP 5',
    title: 'アフターケア',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20acupuncturist%20explaining%20aftercare%20instructions%20to%20patient%2C%20both%20sitting%20and%20having%20friendly%20conversation%20in%20consultation%20room%2C%20therapist%20showing%20care%20advice%20materials%2C%20bright%20modern%20clinic%20interior%2C%20warm%20and%20reassuring%20atmosphere%2C%20professional%20healthcare%20communication%2C%20realistic%20photography&width=600&height=400&seq=flow-aftercare&orientation=landscape',
    description: '施術後、スタッフから今後のケア方法や生活習慣のアドバイスをさせていただきます。ご不明な点はお気軽にご質問ください。',
    bgColor: 'bg-accent/20',
  },
];

const StaffSection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <div className="inline-block bg-sub px-4 py-1 rounded-full mb-4">
            <span className="text-primary text-xs font-medium tracking-wider uppercase">Treatment Flow</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4 px-4">
            <strong>施術の流れ</strong>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto px-4">
            <strong>初めての方も安心</strong>してご来院いただけるよう、丁寧にご案内いたします
          </p>
        </div>

        <div className="flex flex-col gap-6 sm:gap-8">
          {flowSteps.map((item, index) => (
            <article
              key={index}
              className={`${item.bgColor} rounded-2xl sm:rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group`}
            >
              <div className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} items-center`}>
                <div className="w-full md:w-2/5 h-64 sm:h-72 md:h-80">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="w-full md:w-3/5 p-6 sm:p-8 md:p-10">
                  <div className="inline-block bg-primary text-white px-4 py-1 rounded-full mb-4 text-xs font-medium tracking-wider">
                    {item.step}
                  </div>
                  <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-4 sm:mb-6">{item.title}</h3>
                  <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffSection;